import { useMutation } from '@tanstack/react-query';
import { AddImages, CreateDiscover, DeleteDiscover, DragAndDropDiscovers, UpdateDiscover } from '../../../Api/discover';

/**
 * Image upload mutate function
 * @returns "Returns Image url"
 */
export const useMutateCreateImage = () =>
    useMutation({
        mutationFn: (data) => AddImages(data),
    });

/**
 * Add discover mutate function
 * @returns "Returns data of added record"
 */
export const useMutateCreateDiscover = () =>
    useMutation({
        mutationFn: (data) => CreateDiscover(data),
    });

/**
 * Delete discover mutate function
 * @returns "Delete the discover record"
 */
export const useMutateDeleteDiscover = () =>
    useMutation({
        mutationFn: (data) => DeleteDiscover(data),
    });

/**
 * Update discover mutate function
 * @returns "Edit discover record"
 */
export const useMutateEditDiscover = () =>
    useMutation({
        mutationFn: (data) => UpdateDiscover(data),
    });

/**
 * Drag and drop discover mutate function
 * @returns "Drag and drop discover"
 */
export const useMutateDragDropDiscover = () =>
    useMutation({
        mutationFn: (data) => DragAndDropDiscovers(data),
    });